export enum CapiInternalEventName {
  SUBSCRIBE = "Subscribe",
}
